import styled from "@emotion/styled"

export const McpPlatformWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--cms-text-primary, #0f172a);
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary, #475569);
    font-size: 13px;
  }

  .tabs-shell {
    border: 1px solid var(--cms-border, #dde6f3);
    border-radius: 14px;
    background: var(--cms-surface-secondary, #fff);
    overflow: hidden;
  }

  .tabs-head {
    border-bottom: 1px solid var(--cms-border, #dbe3f1);
    background: var(--cms-surface-muted, #f4f7fe);
    padding: 0 10px;
  }

  .tabs-head .MuiTab-root {
    text-transform: none;
    font-weight: 600;
    min-height: 48px;
  }

  .tab-panel {
    padding: 16px;
  }
`
